import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class TimeZoneService {

    private apiEndPoint = environment.apiBaseUrl + 'api/timezone/';

    constructor(private http: HttpClient) { }

    getSelectListItems() {
        return this.http.get(this.apiEndPoint + 'get-select-list-items');
    }

    getAll() {
        return this.http.get(this.apiEndPoint + 'list');
    }
}
